import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-0.5 p-0.5" }
const _hoisted_2 = {
  key: 0,
  class: "mt-0.5 flex flex-col gap-0.5"
}
const _hoisted_3 = {
  key: 1,
  class: "py-3 px-6 text-sm text-dark-800"
}

import { ComputedRef, Ref, computed, ref } from 'vue';
import { RouteLocationNamedRaw, Router, useLink, useRouter } from 'vue-router';
import { MarketCategoriesConfigCategory } from '@/interfaces/market-config';
import { MarketCategoriesConfigKey, TranslateKey, useInject } from '@/composables/use-inject';
import CategorySidemenuItem from '@/components/CategorySidemenu/CategorySidemenuItem.vue';
import CategorySidemenuSubItem from '@/components/CategorySidemenu/CategorySidemenuSubItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySidemenuList',
  emits: {
  effect: null,
  navigate: null,
},
  setup(__props, { emit }) {



const translate = useInject(TranslateKey);
const marketCategoriesConfig = useInject(MarketCategoriesConfigKey);
const router: Router = useRouter();

const volatilePriceItems: Ref<HTMLElement | null> = ref(null);
const inRegistrationQueue: Ref<HTMLElement | null> = ref(null);
const items: Ref<Record<number, HTMLElement>> = ref({});

const categories: Ref<MarketCategoriesConfigCategory[]> = ref(marketCategoriesConfig.categories);
const activeMainCategory: Ref<number | null> = ref(null);

/**
 * Volatile Price Items
 */
const volatilePriceItemsRoute: RouteLocationNamedRaw = { name: 'hot' };
const { isActive: volatilePriceItemsActiveRoute } = useLink({ to: volatilePriceItemsRoute });

const volatilePriceItemsActive: ComputedRef<boolean> = computed((): boolean => {
  return !activeMainCategory.value && volatilePriceItemsActiveRoute.value;
});

const volatilePriceItemsEffect = (): void => {
  router.push(volatilePriceItemsRoute);
  activeMainCategory.value = null;

  if (volatilePriceItems.value) {
    emit('effect', volatilePriceItems.value);
  }
};

/**
 * In Registration Queue
 */
const inRegistrationQueueRoute: RouteLocationNamedRaw = { name: 'queue' };
const { isActive: inRegistrationQueueActiveRoute } = useLink({ to: inRegistrationQueueRoute });

const inRegistrationQueueActive: ComputedRef<boolean> = computed((): boolean => {
  return !activeMainCategory.value && inRegistrationQueueActiveRoute.value;
});

const inRegistrationQueueEffect = (): void => {
  router.push(inRegistrationQueueRoute);
  activeMainCategory.value = null;

  if (inRegistrationQueue.value) {
    emit('effect', inRegistrationQueue.value);
  }
};

/**
 * Injected from marketCategoriesConfig
 */
const categorySidemenuItemEffect = (mainCategory: number): void => {
  const isAlreadyActive = activeMainCategory.value === mainCategory;
  activeMainCategory.value = !isAlreadyActive ? mainCategory : null;

  if (activeMainCategory.value) {
    emit('effect', items.value[activeMainCategory.value]);
  }
};

const categorySidemenuSubItemEffect = (mainCategory: number): void => {
  activeMainCategory.value = mainCategory;
  emit('navigate');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createVNode(CategorySidemenuItem, {
      ref: (component) => (volatilePriceItems.value = component?.$el),
      title: _unref(translate)('sidemenu.volatilePriceItems'),
      icon: "other/volatile-price-items.png",
      active: _unref(volatilePriceItemsActive),
      onEffect: volatilePriceItemsEffect
    }, null, 8, ["title", "active"]),
    _createVNode(CategorySidemenuItem, {
      ref: (component) => (inRegistrationQueue.value = component?.$el),
      title: _unref(translate)('sidemenu.inRegistrationQueue'),
      icon: "other/in-registration-queue.png",
      active: _unref(inRegistrationQueueActive),
      onEffect: inRegistrationQueueEffect
    }, null, 8, ["title", "active"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
      return (_openBlock(), _createBlock(CategorySidemenuItem, {
        key: category.mainCategory,
        ref_for: true,
        ref: (component) => (items.value[category.mainCategory] = component?.$el),
        title: _unref(translate)(category.title),
        icon: category.icon,
        active: activeMainCategory.value === category.mainCategory,
        onEffect: ($event: any) => (categorySidemenuItemEffect(category.mainCategory))
      }, {
        after: _withCtx((after) => [
          (category.subCategories)
            ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_2, [
                (category.subCategories.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(category.subCategories, (subCategory) => {
                      return (_openBlock(), _createBlock(CategorySidemenuSubItem, {
                        key: subCategory.subCategory,
                        title: _unref(translate)(subCategory.title),
                        "main-category": category.mainCategory,
                        "sub-category": subCategory.subCategory,
                        onEffect: ($event: any) => (categorySidemenuSubItemEffect(category.mainCategory))
                      }, null, 8, ["title", "main-category", "sub-category", "onEffect"]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_unref(translate)('sidemenu.emptyCategory')), 1))
              ], 512)), [
                [_vShow, after.active]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["title", "icon", "active", "onEffect"]))
    }), 128))
  ]))
}
}

})